import { Cpu, Building2, ShieldCheck, Landmark } from "lucide-react";
import { useApp } from "@/context/AppContext";

export const TOPICS = [
  { slug: "ai", label: "AI", icon: Cpu, desc: "Automation & intelligence" },
  { slug: "real-estate", label: "Real Estate", icon: Building2, desc: "Close more deals" },
  { slug: "insurance", label: "Insurance", icon: ShieldCheck, desc: "Sell smarter" },
  { slug: "loans", label: "Loans", icon: Landmark, desc: "Master lending" },
];

export default function TopicPicker({ onSelect, active }) {
  const { selectTopic } = useApp();
  const handle = (slug) => {
    selectTopic(slug);
    onSelect?.(slug);
  };
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="topic-picker">
      {TOPICS.map((t) => {
        const Icon = t.icon;
        const isActive = active === t.slug;
        return (
          <button
            key={t.slug}
            data-testid={`topic-${t.slug}`}
            onClick={() => handle(t.slug)}
            className={`asf-card p-6 text-left ${isActive ? "border-asf-orange/70 !translate-y-0" : ""}`}
          >
            <span className={`grid place-items-center h-12 w-12 rounded-xl mb-4 ${isActive ? "bg-asf-orange text-white" : "bg-slate-100 text-asf-orange"}`}>
              <Icon className="h-6 w-6" />
            </span>
            <div className="font-display text-lg font-semibold">{t.label}</div>
            <div className="text-xs text-slate-500 mt-1">{t.desc}</div>
          </button>
        );
      })}
    </div>
  );
}
